import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icons from "assets/icons";
import Icon from "@ant-design/icons";
import React from "react";
import {Space, Button, Typography, Row} from "antd";

const {RADIO_BUTTON, INPUT, RADIO} = FIELD_TYPE;

const labelCol = {xs: 6, md: 6, lg: 6};
const wrapperCol = {xs: 18, md: 18, lg: 18};
const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};

export const FieldsIris1: any[] = [
  {
    name: ["rightJsonValue", "IRIS", "Hình dạng"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hình dạng",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 12,
      },
      {
        label: "Tổn thương",
        value: "Tổn thương",
        span: 12,
      },
    ],
    value: "Bình thường",
  },
  {
    label: "Tân mạch",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "IRIS", "Tân mạch"],
    radioButtons: [
      {
        label: "Không",
        value: false,
        span: 12,
      },
      {
        label: "Có",
        value: true,
        span: 12,
      },
    ],
    value: false,
  },
  {
    name: ["rightJsonValue", "IRIS", "Dính mống"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Dính mống",
    radioButtons: [
      {
        label: "Không",
        value: false,
        span: 8,
      },
      {
        label: "Trước",
        value: "Trước",
        span: 8,
      },
      {
        label: "Sau",
        value: "Sau",
        span: 8,
      },
    ],
    value: false,
  },
  {
    label: "Lỗ mống mắt chu biên",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "IRIS", "Lỗ mống mắt chu biên"],
    radioButtons: [
      {
        label: "Không",
        value: false,
        span: 12,
      },
      {
        label: "Có",
        value: true,
        span: 12,
      },
    ],
    value: false,
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "IRIS", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "IRIS", "show"],
    hide: true,
  },
];

export const FieldsIris2: any[] = [
  {
    name: ["leftJsonValue", "IRIS", "Hình dạng"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hình dạng",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 12,
      },
      {
        label: "Tổn thương",
        value: "Tổn thương",
        span: 12,
      },
    ],
    value: "Bình thường",
  },
  {
    label: "Tân mạch",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "IRIS", "Tân mạch"],
    radioButtons: [
      {
        label: "Không",
        value: false,
        span: 12,
      },
      {
        label: "Có",
        value: true,
        span: 12,
      },
    ],
    value: false,
  },
  {
    name: ["leftJsonValue", "IRIS", "Dính mống"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Dính mống",
    radioButtons: [
      {
        label: "Không",
        value: false,
        span: 8,
      },
      {
        label: "Trước",
        value: "Trước",
        span: 8,
      },
      {
        label: "Sau",
        value: "Sau",
        span: 8,
      },
    ],
    value: false,
  },
  {
    label: "Lỗ mống mắt chu biên",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "IRIS", "Lỗ mống mắt chu biên"],
    radioButtons: [
      {
        label: "Không",
        value: false,
        span: 12,
      },
      {
        label: "Có",
        value: true,
        span: 12,
      },
    ],
    value: false,
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "IRIS", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "IRIS", "show"],
    hide: true,
  },
];
